<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button type="primary" v-if="$permission.canWrite()" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" v-if="$permission.canDel()" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <template v-if="$permission.canEdit()&&row.State!=2">
              <el-button type="text" icon="el-icon-edit" @click="editById(row.RecordId)"></el-button>
            </template>
            <template v-if="!$permission.canEdit()">
              <el-button type="text" icon="el-icon-edit" @click="editById(row.RecordId)"></el-button>
            </template>
            <el-button type="text" icon="el-icon-document" v-if="$permission.canReview()" @click="details(row.RecordId)"></el-button>
            <template v-if="$permission.canDel()&&row.State!=2">
              <el-button type="text" icon="el-icon-delete" @click="del(row.RecordId)"></el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/wh/indoc/list";
import editDialog from "@/components/wh/indoc/editDialog";
import detailsDialog from "@/components/wh/indoc/detailsDialog";

export default {
  name: "indoc",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog
  },
  methods: {
    details(id) {
      this.$refs.detailsDialog.openDetailsById(id);
    },
    del(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange([id]);
        })
        .catch(() => { });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RecordId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>